<template>



<a-drawer :title="`${model.media === 1 ? '创意':'广告'}报表数据 (${model.show_name})`" :width="1550" :visible="showPromotionReportPage" :body-style="{ paddingBottom: '1px' }"
@close="close">
              <div class="report-page">
                    <template>
                      <vxe-grid
                        class="table-scrollbar"
                        v-bind="tableGrid"
                        @page-change="handlePageChange"
                        @sort-change="handleSortChange"
                      >

                      <template #toolbar_buttons>
                        <div class="search-wrapper" style="background:#f8f8f9;padding:0px;margin:0px;height:70px">
                          <div class="title" style="height:10px;line-height:10px"><a-icon type="search" /> 数据筛选</div>
                          <a-space style="margin-top:15px">
                              <a-range-picker v-model="queryParam.date" valueFormat="YYYY-MM-DD"  :allowClear="false"/>
                              <a-button type="primary" @click="search">查询</a-button>
                          </a-space>
                      </div>
                      </template>

                      <template #bid="{ row }">
                        <span v-if="row.bid">
                          {{ row.bid }} <a href="#" @click="showFormPage(row, 'bid')" v-if="model.media === 2"> 修改 </a> 
                        </span>
                        <span v-else> - </span>
                      </template>

                      <template #yjql="{ row }">
                        <span v-if="row.promotion_raise_status">
                           <a href="#" @click="showYjqlFormPage(row)" v-if="accessTo('getYjql')"> {{ row.promotion_raise_status.name }} </a> 
                           <span v-else> {{ row.promotion_raise_status.name }} </span>
                        </span>
                        <span v-else> - </span>
                      </template>

                      <template #status="{ row }">
                        <div>
                          {{ row.status_name }}<br>
                          
                          <div v-if="model.media === 1">
                            <a-tag color="green" v-if="row.opt_status === 1 ">投放中</a-tag>
                            <a-tag color="red" v-else>暂停</a-tag>
                          </div>
                          <div v-else>
                            <a-switch 
                            v-if="accessTo('update')"
                            v-model="row.show_opt_status"
                            @change="updatePromotion(row.promotion_id, 'opt_status',  row.opt_status)"
                          />
                          </div>
                        
                        </div>
                      </template>

                      <template #budget="{ row }">
                        <div>
                          <span v-if="model.media == 2">
                            {{ row.budget_mode === 'BUDGET_MODE_INFINITE' ? '不限' : '日预算' }}<br>
                          </span>
                          【{{ row.budget || '-' }}】<br>
                        </div>
                      </template>

                      <template #name="{ row }">
                        <div>
                          {{ row.name || '-' }}<br>
                          【{{ row.promotion_id || '-' }}】<br>
                        </div>
                      </template>

                      <template #toutiao_conversion="{ row }">
                        <div>
                          成本：{{ row.conversion_cost || '-' }}<br>
                          转化率：{{ row.conversion_rate ? row.conversion_rate + '%' : '-' }}<br>
                        </div>
                      </template>

                      <template #real_conversion="{ row }">
                        <div>
                          转化数：{{ row.real_conversion_cnt || '-' }}<br>
                          转化成本：{{ row.real_conversion_cost ? row.real_conversion_cost : '-' }}<br>
                        </div>
                      </template>

                        <template #action="{ row }">
                          <div style="height:46px;line-height:46px">
                            <template v-if="accessTo('PromotionController@copy')">
                              <a href="#" @click="copyPromotion(row)">复制</a>
                              <a-divider type="vertical"/>
                            </template>
                           
                            <template v-if="accessTo('OrderController@index')">
                              <a href="#" @click="jumpToOrder(row)">查看订单</a>
                            </template>
                          </div>
                        </template>
                      </vxe-grid>
                    </template>
              </div>



              <a-modal
                title="复制广告"
                centered
                :width="800"
                :mask-closable="false"
                :visible="showCopyForm"
                :confirmLoading="loading"
                @cancel="closePromotionForm"
              >
              <a-form-model
                ref="form"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                >
                  <a-spin :spinning="loading">
                    <a-form-model-item label="新广告名称" prop="miniapp_path">
                      <a-input v-model="new_ad_name" />
                    </a-form-model-item>
                  </a-spin>
                </a-form-model>
          
              <template slot="footer">
                <a-button @click="closePromotionForm" :disabled="loading">取消</a-button>
                <a-button type="primary" @click="submitPromotion" :disabled="loading">确定</a-button>
              </template>
            </a-modal>

            <create-form
              v-if="showForm"
              :showForm.sync="showForm"
              :model="modelForm"
              @success="refresh"
            />

            <yjql-form
              v-if="showYjqlForm"
              :showYjqlForm.sync="showYjqlForm"
              :model="modelYjql"
              @success="refresh"
            />

</a-drawer>
    
</template>

<style lang="less" scoped>
@import 'Report';
</style>

<script>
import Report from './Report'
export default Report
</script>
